import { React, variantProvider } from '@/app'
import { Button, View } from '@/components'

export const ContributeLayout = (props: React.PropsWithChildren<{ tabBarShown?: boolean }>) => {
  const { children } = props

  return (
    <>
      <View style={styles.wrapper}>{children}</View>
    </>
  )
}

type FooterProps = { backText?: string; onBack?: () => any; onConfirm?: () => any; canPost?: boolean }

const ContributeFooter = (props: FooterProps) => {
  return (
    <View variants={['row', 'justifySpaceBetween']}>
      <Button
        debugName='Go back from contribute footer'
        icon='arrow-left'
        text={props?.backText ?? 'Back'}
        onPress={props.onBack}
        variants={['outline', 'large']}
      />
      <Button
        debugName='Confirm post'
        rightIcon='send'
        text={'Post'}
        onPress={props.onConfirm}
        disabled={!props.canPost}
        variants={['large']}
      />
    </View>
  )
}

const ContributeBox = (props: React.PropsWithChildren) => {
  const { children } = props

  return <View style={styles.box}>{children}</View>
}

ContributeLayout.Box = ContributeBox
ContributeLayout.Footer = ContributeFooter

const styles = variantProvider.createComponentStyle(
  theme => ({
    box: {
      backgroundColor: theme.colors.neutral1,
      borderRadius: theme.borderRadius.medium,
      ...theme.spacing.padding(2),
      ...theme.presets.column,
      maxWidth: 700,
      width: `calc(100vw - ${theme.spacing.value(2)}px)`,
    },
    wrapper: {
      ...theme.presets.column,
      ...theme.spacing.gap(3.5),
    },
  }),
  true,
)
